import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useDropzone } from 'react-dropzone'
import { useToast } from '@machobear/design-system'
import { colors, fontWeights } from '@/styles'
import UploadDocumentIcon from './upload-document-icon.svg'
const MAX_SIZE_MB = 5
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1048576

const AddNewDocumentsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0px 48px;
  width: 100%;
  height: 96px;
  border: 1.5px dashed ${colors.grey80};
  border-radius: 8px;
  cursor: pointer;

  &:hover,
  &:active {
    background-color: ${colors.blue96};
    border: 1.5px dashed ${colors.blue80};
  }

  ${props =>
    props.isDragActive &&
    `
    background-color: ${colors.blue96};
    border: 1.5px dashed ${colors.blue80};
  `};
`

const AddNewDocumentsIconStyle = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 12px;
`

const AddNewDocumentsContainerTextWrapper = styled.div`
  font-size: 14px;
  color: ${colors.blue16};
`

const AddNewDocumentsContainerText = styled.p`
  margin: 0;
  font-size: ${props => props.size};
  color: ${props => props.color};
  strong {
    font-weight: ${fontWeights.medium};
    color: ${colors.link};
  }
`

const AddDocumentButton = ({ handleUploadFile, isPrimary = false }) => {
  const { t } = useTranslation()
  const showToast = useToast()
  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    accept: {
      'application/pdf': ['.pdf']
    },
    multiple: !isPrimary,
    noKeyboard: true,
    maxSize: MAX_SIZE_BYTES,
    onDropRejected: () => {
      showToast({
        message: t('l.contract.add.max_file_size.text', 'Max file size: 5 mb. PDF only.'),
        tone: 'critical'
      })
    },
    onDropAccepted: handleUploadFile
  })

  return (
    <AddNewDocumentsContainer onClick={open} isDragActive={isDragActive} {...getRootProps()}>
      <AddNewDocumentsIconStyle src={UploadDocumentIcon} alt="add" />
      <AddNewDocumentsContainerTextWrapper>
        <AddNewDocumentsContainerText>
          {t(
            'l.contract_manager.documents.drag_drop_pdf.label',
            'Drag and drop your PDF file here or '
          )}
          <strong>{t('l.contract_manager.documents.browse.label', 'Browse')}</strong>
        </AddNewDocumentsContainerText>

        <AddNewDocumentsContainerText size={'12px'} color={'#6b6b6b'}>
          {t('l.contract_manager.documents.pdf_max_file.label', 'Add PDF. Max file size: 5MB')}
        </AddNewDocumentsContainerText>
        <input name="avatarInput" {...getInputProps()} />
      </AddNewDocumentsContainerTextWrapper>
    </AddNewDocumentsContainer>
  )
}

export default AddDocumentButton
